import { styled } from "@mui/material";
import { ColorSAP, FONT_FAMILY } from "../../ontego-ui";

const Styled = {};

Styled.Menu = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 32,
  width: "100%",
}));

Styled.MenuItem = styled("div")(({ isActive }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 12,
  alignItems: "flex-start",
  justifyContent: "center",
  padding: 20,
  borderRadius: 16,
  cursor: "pointer",
  borderLeft: `6px solid ${isActive ? ColorSAP.primary[60] : ColorSAP.neutral[40]}`,
  backgroundColor: isActive ? ColorSAP.primary[10] : ColorSAP.neutral[15],
  transition: "background-color 0.2s ease, border-color 0.2s ease",
  "&:hover": {
    backgroundColor: isActive ? ColorSAP.primary[10] : ColorSAP.neutral[20],
  },
}));

Styled.MenuIcon = styled("div")(({ isActive }) => ({
  width: 32,
  height: 32,
  flexShrink: 0,
  "& svg": {
    width: "32px !important",
    height: "32px !important",
    color: isActive ? ColorSAP.primary[80] : ColorSAP.neutral[40],
    transition: "color 0.2s ease",
  },
}));

Styled.MenuLabel = styled("p")(({ isActive }) => ({
  fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD,
  fontSize: 18,
  lineHeight: "25px",
  margin: 0,
  color: isActive ? ColorSAP.primary[80] : ColorSAP.neutral[70],
  transition: "color 0.2s ease",
}));

export default Styled;
